var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRequestExtendDeadline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M14.08 4.639c.541 0 .983.441.983.983v3.612l-.972-.647a.585.585 0 0 0-.325-.099h-4.08a.985.985 0 0 1-.944-.71h1.572a2.157 2.157 0 0 0 2.155-2.156V4.64zm.271 1.924a.586.586 0 1 0-1.172 0 .586.586 0 0 0 1.172 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M18.159.255A1.84 1.84 0 0 1 20 2.096v9.456H0V2.096A1.84 1.84 0 0 1 1.841.256zM16.234 10.33V5.622a2.158 2.158 0 0 0-2.155-2.155h-1.628a2.153 2.153 0 0 0-2.137-1.883H5.92c-1.19 0-2.156.963-2.156 2.155v4.707c0 .468.523.747.911.488l1.736-1.157h1.137A2.158 2.158 0 0 0 9.686 9.66h3.902l1.735 1.157c.39.259.911-.02.911-.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M11.297 5.622a.984.984 0 0 1-.983.983h-4.08a.586.586 0 0 0-.325.099l-.972.647V3.74c0-.548.445-.983.984-.983h4.393c.548 0 .983.445.983.983zM6.82 4.681a.586.586 0 1 0-1.172 0 .586.586 0 0 0 1.172 0zm1.883 0a.586.586 0 1 0-1.172 0 .586.586 0 0 0 1.172 0zM10 5.267a.586.586 0 1 0 0-1.172.586.586 0 0 0 0 1.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M0 13.393a1.84 1.84 0 0 0 1.841 1.841h7.573v1.339H6.862a.586.586 0 1 0 0 1.172h6.276a.586.586 0 0 0 0-1.172h-2.552v-1.339h7.573a1.84 1.84 0 0 0 1.84-1.84v-.67H0z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequestExtendDeadline);
export default __webpack_public_path__ + "static/media/icon-request-extend-deadline.23101c39.svg";
export { ForwardRef as ReactComponent };